function Footer() {
    return null; // Footer is already in sidebar
  }
  
  export default Footer;